import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as SVG } from "../img/dev-ops-icon-optimized.svg";
import gsap from "gsap";
import * as Utilities from "./AnimationUtilities";

const COLORS = {
  pathInactive: "#fafafa",
  pathActive: "orange",
};

const useStyles = makeStyles((theme) => ({
  animationContainer: {
    position: "relative",
    height: "100%",
    width: "100px",
    visibility: "hidden",
    margin: "auto",
  },
  svg: {
    height: "43px",
    width: "auto",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    zIndex: 100,
    "& #path-pieces path": {
      fill: COLORS.pathInactive,
    },
    "& #background": {
      visibility: "hidden",
    },
  },
}));

function DevOpsIcon(props) {
  const animationContainerRef = React.useRef();
  const svgRef = React.useRef();

  useEffect(() => {
    // ELEMENTS
    const animationContainer = animationContainerRef.current;
    const svg = svgRef.current;

    // SETUP
    Utilities.centerElement(svg);

    // animation elements
    const pathPieces = [
      svg.querySelector("#path-pieces #path-piece-plan"),
      svg.querySelector("#path-pieces #path-piece-code"),
      svg.querySelector("#path-pieces #path-piece-build"),
      svg.querySelector("#path-pieces #path-piece-test"),
      svg.querySelector("#path-pieces #path-piece-release"),
      svg.querySelector("#path-pieces #path-piece-deploy"),
      svg.querySelector("#path-pieces #path-piece-operate"),
      svg.querySelector("#path-pieces #path-piece-monitor"),
    ];

    // ANIMATE
    const mainTL = gsap.timeline();
    mainTL.set([animationContainer, svg], { autoAlpha: 1 });
    mainTL.add(animatePathPieces(pathPieces));
  }, []);

  const classes = useStyles();

  return (
    <div ref={animationContainerRef} className={classes.animationContainer}>
      <SVG ref={svgRef} className={classes.svg} />
    </div>
  );
}

// animation functions
function animatePathPieces(pieces) {
  const tl = gsap.timeline();
  const numberOfPieces = pieces.length;
  const duration = 0.3;
  const pause = 0.4;
  const stagger = duration + pause;
  const repeatDelay = stagger * (numberOfPieces - 1) + pause;

  tl.to(pieces, {
    fill: COLORS.pathActive,
    duration: duration,
    stagger: { repeat: -1, each: stagger, repeatDelay },
  });
  tl.to(
    pieces,
    {
      fill: COLORS.pathInactive,
      duration: duration,
      stagger: {
        each: stagger,
        repeat: -1,
        repeatDelay: repeatDelay,
      },
    },
    stagger
  );

  return tl;
}

export default DevOpsIcon;
